(function () {

  // -----------------------------------------------
  // FIX 8: Remove tabindex + role from jdgm non-interactive elements
  // -----------------------------------------------
  function fixJdgm() {
    document.querySelectorAll([
      '.jdgm-all-reviews-rating',
      '.jdgm-carousel-item__review-rating',
      '.jdgm-carousel__left-arrow',
      '.jdgm-carousel__right-arrow',
      '.jdgm-star',
      'span[role="img"][tabindex]',
      'div[role="img"][tabindex]'
    ].join(', ')).forEach(function (el) {
      el.removeAttribute('tabindex');
      el.removeAttribute('role');
      console.log('[A11y Fix 8] Removed tabindex + role from:', el.tagName, el.className);
    });
  }

  // -----------------------------------------------
  // FIX 9: Remove prohibited role from native interactive elements
  // summary[role="button"] — 57 issues in report
  // button[role="presentation"] — multiple issues
  // div/li/label[role="button"] missing keyboard focus — Blocker issues
  // -----------------------------------------------
  function fixProhibitedRoles() {
    // summary[role="button"] — role is invalid on <summary>
    document.querySelectorAll('summary[role="button"]').forEach(function (el) {
      el.removeAttribute('role');
      console.log('[A11y Fix 9] Removed role="button" from <summary>');
    });

    // button[role="presentation"] — invalid, also causes aria-label to be prohibited
    document.querySelectorAll('button[role="presentation"], button[role]').forEach(function (el) {
      el.removeAttribute('role');
      console.log('[A11y Fix 9] Removed role from <button>');
    });

    // input[role] — prohibited (combobox etc.)
    document.querySelectorAll('input[role]').forEach(function (el) {
      el.removeAttribute('role');
      console.log('[A11y Fix 9] Removed role from <input>');
    });

    // select/textarea with role — prohibited
    document.querySelectorAll('select[role], textarea[role]').forEach(function (el) {
      el.removeAttribute('role');
      console.log('[A11y Fix 9] Removed role from <' + el.tagName.toLowerCase() + '>');
    });
  }

  // -----------------------------------------------
  // FIX 10: Fix div/li/label with role="button" — add tabindex + keyboard support
  // Blocker: "Button fails to receive keyboard focus"
  // Affects: .policy-card_block-main, #selectedItem, .block__product-tab-nav-item,
  //          .swatch-input__label, and any other div/li/label with role="button"
  // -----------------------------------------------
  function fixFakeButtons() {
    document.querySelectorAll([
      'div[role="button"]',
      'li[role="button"]',
      'label[role="button"]',
      'span[role="button"]'
    ].join(', ')).forEach(function (el) {
      // Add tabindex if missing so keyboard can reach it
      if (!el.hasAttribute('tabindex')) {
        el.setAttribute('tabindex', '0');
        console.log('[A11y Fix 10] Added tabindex="0" to role=button element:', el.tagName, el.className.split(' ')[0]);
      }
      // Add keyboard Enter/Space support if not already present
      if (!el._a11yKeyFixed) {
        el._a11yKeyFixed = true;
        el.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            el.click();
          }
        });
        console.log('[A11y Fix 10] Added keydown handler to role=button:', el.tagName, el.className.split(' ')[0]);
      }
    });
  }

  // -----------------------------------------------
  // FIX 11: Unique aria-label for multiple search landmarks
  // Multiple <form role="search"> with no aria-label
  // -----------------------------------------------
  function fixSearchLandmarks() {
    var searchForms = document.querySelectorAll('[role="search"]:not([aria-label]):not([aria-labelledby])');
    searchForms.forEach(function (el, i) {
      var label = i === 0 ? 'Site search' : 'Site search ' + (i + 1);
      el.setAttribute('aria-label', label);
      console.log('[A11y Fix 11] Added aria-label to search landmark:', label);
    });
  }

  // -----------------------------------------------
  // FIX 12: Add aria-label to cart/add-to-cart forms
  // Multiple form landmarks with no accessible name
  // -----------------------------------------------
  function fixFormLandmarks() {
    document.querySelectorAll('form[data-type="add-to-cart-form"]:not([aria-label]):not([aria-labelledby])').forEach(function (form) {
      // Try to get product name from submit button aria-label or nearby heading
      var btn = form.querySelector('button[type="submit"]');
      var label = (btn && btn.getAttribute('aria-label')) ||
                  (form.closest('[data-product-title]') && form.closest('[data-product-title]').getAttribute('data-product-title')) ||
                  'Add to cart';
      form.setAttribute('aria-label', label);
      console.log('[A11y Fix 12] Added aria-label to cart form:', label);
    });

    // Newsletter/contact forms
    document.querySelectorAll('form#ContactFooter:not([aria-label])').forEach(function (form) {
      form.setAttribute('aria-label', 'Newsletter signup');
      console.log('[A11y Fix 12] Added aria-label to newsletter form');
    });
  }

  // -----------------------------------------------
  // FIX 13: Unique aria-label for duplicate announcement region landmarks
  // Multiple role="region" aria-label="Announcement"
  // -----------------------------------------------
  function fixDuplicateRegions() {
    var groups = {};
    document.querySelectorAll('[role="region"][aria-label]').forEach(function (el) {
      var lbl = el.getAttribute('aria-label');
      if (!groups[lbl]) groups[lbl] = [];
      groups[lbl].push(el);
    });
    Object.keys(groups).forEach(function (lbl) {
      var els = groups[lbl];
      if (els.length < 2) return;
      els.forEach(function (el, i) {
        if (i === 0) return;
        el.setAttribute('aria-label', lbl + ' ' + (i + 1));
        console.log('[A11y Fix 13] Updated duplicate region aria-label to:', lbl + ' ' + (i + 1));
      });
    });
  }

  // -----------------------------------------------
  // FIX 14: Add accessible name to iframe
  // -----------------------------------------------
  function fixIframes() {
    document.querySelectorAll('iframe:not([title]):not([aria-label])').forEach(function (iframe) {
      var src = iframe.src || '';
      var label = src.indexOf('preview-bar') > -1 ? 'Preview bar' : 'Content frame';
      iframe.setAttribute('title', label);
      console.log('[A11y Fix 14] Added title to iframe:', label);
    });
  }

  // -----------------------------------------------
  // MAIN: Apply all fixes
  // -----------------------------------------------
  function applyA11yFixes(root) {
    root = root || document;

    // FIX 1: Remove prohibited role="combobox" from <input>
    root.querySelectorAll('input[role="combobox"]').forEach(function (input) {
      input.removeAttribute('role');
      console.log('[A11y Fix 1] Removed role="combobox" from input:', input.id || input.name);
    });

    // FIX 2: Remove prohibited role="button" from <summary>
    root.querySelectorAll('summary[role="button"]').forEach(function (summary) {
      summary.removeAttribute('role');
      console.log('[A11y Fix 2] Removed role="button" from summary:', summary.textContent.trim().slice(0, 40));
    });

    // FIX 2b: Remove any role attribute from .block__header--megamenulist
    var megaMenuTargets = (root === document)
      ? document.querySelectorAll('.block__header--megamenulist')
      : (root.matches && root.matches('.block__header--megamenulist') ? [root] : root.querySelectorAll('.block__header--megamenulist'));
    megaMenuTargets.forEach(function (el) {
      if (el.hasAttribute('role')) {
        el.removeAttribute('role');
        console.log('[A11y Fix 2b] Removed role from .block__header--megamenulist');
      }
    });

    // FIX 3: Fix missing accessible name on image links
    root.querySelectorAll('a:has(img):not([aria-label]):not([aria-labelledby])').forEach(function (link) {
      var img = link.querySelector('img');
      var altText = img && img.alt && img.alt.trim();
      var srcName = img && img.src
        ? img.src.split('/').pop().replace(/[-_]/g, ' ').replace(/\.[^.]+$/, '')
        : '';
      var label = altText || srcName || 'Image link';
      link.setAttribute('aria-label', label);
      console.log('[A11y Fix 3] Added aria-label to image link:', label);
    });

    // FIX 4: Fix identical link texts pointing to different URLs
    var linkGroups = {};
    root.querySelectorAll('a[href]').forEach(function (link) {
      var text = link.textContent.trim().toLowerCase();
      if (!text) return;
      if (!linkGroups[text]) linkGroups[text] = [];
      linkGroups[text].push(link);
    });
    Object.entries(linkGroups).forEach(function (entry) {
      var text = entry[0], links = entry[1];
      if (links.length < 2) return;
      var hrefs = new Set(links.map(function (l) { return l.getAttribute('href'); }));
      if (hrefs.size <= 1) return;
      links.forEach(function (link) {
        if (link.getAttribute('aria-label')) return;
        var nearestHeading = link.closest('li, article, div') &&
          link.closest('li, article, div').querySelector('h1,h2,h3,h4,h5,h6');
        var context =
          link.getAttribute('data-product-title') ||
          link.getAttribute('title') ||
          (nearestHeading && nearestHeading.textContent.trim());
        if (context && context.toLowerCase() !== text) {
          link.setAttribute('aria-label', text + ' - ' + context);
          console.log('[A11y Fix 4] Added aria-label to duplicate link:', text + ' - ' + context);
        }
      });
    });

    // FIX 5: Remove tabindex="0" from non-interactive elements (no role, no onclick)
    var nonInteractiveTags = ['div', 'span', 'section', 'article', 'aside', 'main', 'header', 'footer', 'p', 'ul', 'li'];
    root.querySelectorAll(
      nonInteractiveTags.map(function (t) { return t + '[tabindex="0"]'; }).join(',')
    ).forEach(function (el) {
      if (!el.hasAttribute('role') && !el.onclick && !el.getAttribute('onclick')) {
        el.removeAttribute('tabindex');
        console.log('[A11y Fix 5] Removed tabindex="0" from:', el.tagName, el.className.split(' ')[0]);
      }
    });

    // FIX 6: Ensure search input has accessible name
    root.querySelectorAll('input[type="search"]').forEach(function (input) {
      var hasLabel =
        input.getAttribute('aria-label') ||
        input.getAttribute('aria-labelledby') ||
        (input.id && document.querySelector('label[for="' + input.id + '"]'));
      if (!hasLabel) {
        input.setAttribute('aria-label', 'Search');
        console.log('[A11y Fix 6] Added aria-label="Search" to search input:', input.id);
      }
    });

    // Run global fixes
    fixJdgm();
    fixProhibitedRoles();
    fixFakeButtons();
    fixSearchLandmarks();
    fixFormLandmarks();
    fixDuplicateRegions();
    fixIframes();
  }

  // -----------------------------------------------
  // Run on DOM ready
  // -----------------------------------------------
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      applyA11yFixes(document);
    });
  } else {
    applyA11yFixes(document);
  }

  // -----------------------------------------------
  // MutationObserver — catches dynamically injected elements
  // -----------------------------------------------
  var observer = new MutationObserver(function (mutations) {
    var hasNewNodes = false;
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === Node.ELEMENT_NODE) {
          hasNewNodes = true;
          applyA11yFixes(node);
            document.querySelectorAll('a[role="heading"]').forEach(el => {
              el.removeAttribute('role');
              el.removeAttribute('aria-level');
            });

             document.querySelectorAll('a button, a [role="button"]').forEach(btn => {
                const parentLink = btn.closest('a');
                if (parentLink) {
                  // Move button to after the link
                  parentLink.parentNode.insertBefore(btn, parentLink.nextSibling);
                }
            });
        }
      });
    });
    if (hasNewNodes) {
      setTimeout(function () {
        fixJdgm();
        fixProhibitedRoles();
        fixFakeButtons();
        fixSearchLandmarks();
        fixFormLandmarks();
        fixDuplicateRegions();
        fixIframes();
      }, 300);
      setTimeout(function () {
        fixJdgm();
        fixProhibitedRoles();
        fixFakeButtons();
      }, 800);
      setTimeout(function () {
        fixJdgm();
        fixProhibitedRoles();
        fixFakeButtons();
      }, 1500);
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // -----------------------------------------------
  // Staggered retries — covers lazy-loaded widgets
  // -----------------------------------------------
  [300, 600, 1000, 1500, 2500, 4000].forEach(function (delay) {
    setTimeout(function () {
      fixJdgm();
      fixProhibitedRoles();
      fixFakeButtons();
      fixSearchLandmarks();
      fixFormLandmarks();
      fixDuplicateRegions();
      fixIframes();
    }, delay);
  });

  console.log('✅ A11y fix script loaded and watching for dynamic content.');
})();